<template>
  <BaseSelect :value="value"
              :options="languagesComputed"
              text-key="name"
              @input="onSelect"
              class="_to-up"/>
</template>

<script>
  export default {
    name: 'EmployersLTPageLocaleSelect',
    props: {
      languages: Object
    },
    data() {
      return {}
    },
    computed: {
      currentLang() {
        const r = this.$route.params.lang
        return r || 'ua'
      },
      value() {
        const currentLang = this.currentLang
        return this.languagesComputed.find(o => o.key === currentLang)
      },
      languagesComputed() {
        const languages = this.languages
        const r = []

        for (const key in languages) {
          const el = languages[key]

          el.key = key
          r.push(el)
        }

        return r
      }
    },
    methods: {
      onSelect(option) {
        this.$store.dispatch('changeCurrentLocale', option.key)
      }
    }
  }
</script>

<style lang="less">

</style>
